export default "__VITE_ASSET__05d54979__"